import { RunState } from "types/generated";
import { AccessResult } from "utils/access";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import RunPhaseLogs from "components/Run/elements/RunPhaseLogs";
import StopRunButton from "components/Run/elements/StopRunButton";
import KillRunButton from "components/Run/elements/KillRunButton";
import { useVisibilityToggle } from "components/Run/hooks/useVisibilityToggle";

import { RunHistoryEntryType } from "../../types";

type DestroyingEntryProps = {
  timestamp: number;
  until: number | null;
  hasLogs: boolean;
  beforeHooks: string[] | undefined;
  afterHooks: string[] | undefined;
  stateVersion: number | null;
  openLogsByDefault: boolean;
  showTerminateButtons: boolean;
  runId: string;
  stackId: string;
  isModuleRun: boolean;
  canStop: AccessResult;
  canKill: AccessResult;
  runQueryToRefetch: string;
};

const DestroyingEntry = ({
  timestamp,
  until,
  hasLogs,
  stateVersion,
  beforeHooks,
  afterHooks,
  openLogsByDefault,
  showTerminateButtons,
  runId,
  stackId,
  isModuleRun,
  canStop,
  canKill,
  runQueryToRefetch,
}: DestroyingEntryProps) => {
  const [showLogs, toggleLogs] = useVisibilityToggle(openLogsByDefault, hasLogs);

  return (
    <HistoryEntryWrapper
      state={RunHistoryEntryType.Destroying}
      timestamp={timestamp}
      until={until}
      isLoading={!until}
      onClick={toggleLogs}
      isOpen={showLogs}
    >
      {showLogs && (
        <RunPhaseLogs
          beforeHooks={beforeHooks}
          afterHooks={afterHooks}
          state={RunState.Destroying}
          stateVersion={stateVersion}
          until={until}
          runId={runId}
          stackId={stackId}
          isModuleRun={isModuleRun}
        >
          {showTerminateButtons && (
            <>
              <StopRunButton
                canStop={canStop}
                runId={runId}
                stackId={stackId}
                runQueryToRefetch={runQueryToRefetch}
              />
              <KillRunButton
                canKill={canKill}
                runId={runId}
                stackId={stackId}
                runQueryToRefetch={runQueryToRefetch}
              />
            </>
          )}
        </RunPhaseLogs>
      )}
    </HistoryEntryWrapper>
  );
};

export default DestroyingEntry;
